import React from 'react';
import tw from 'twin.macro';

interface FadedImageTextProps {
  image: React.ReactNode;
  textSide: 'left' | 'right';
}

const FadedImageText: React.FC<FadedImageTextProps> = ({ image, textSide, children }) => (
  <div tw="my-20 relative">
    <div tw="relative z-20">
      <div
        css={[
          tw`pt-12 pb-12 bg-gradient-to-b from-black`,
          textSide === 'left' ? tw`lg:(bg-gradient-to-r)` : tw`lg:(bg-gradient-to-l)`
        ]}
      >
        <div tw="container">
          <div tw="lg:(grid grid-cols-3)">
            <div
              css={[
                tw`col-span-2 text-white max-w-5xl `,
                textSide === 'right' ? tw`lg:(col-start-2)` : tw``
              ]}
            >
              <div
                css={[tw`max-w-xl`, textSide === 'right' ? tw`lg:(ml-auto)` : tw`lg:(mr-auto)`]}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {image}
  </div>
);

export default FadedImageText;
